import Listeners from 'src/utils/helpers/listeners'

export default new Listeners()
